import {ApplicationConfig, provideBrowserGlobalErrorListeners} from '@angular/core'
import {provideRouter, withComponentInputBinding, withHashLocation} from '@angular/router'

import {routes} from './app.routes'
import {LOCAL_STORAGE} from './0-general/providers'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideHttpClient, withFetch} from '@angular/common/http'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation(), withComponentInputBinding()),
    provideHttpClient(withFetch()),
    {provide: LOCAL_STORAGE, useValue: localStorage},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        appearance: 'outline',
        floatLabel: 'always',
        subscriptSizing: 'dynamic'
      }
    }
  ]
}
